/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductCustomizerRequestModel
 */
export interface ProductCustomizerRequestModel {
    /**
     * 
     * @type {string}
     * @memberof ProductCustomizerRequestModel
     */
    product?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductCustomizerRequestModel
     */
    selectedAddons?: Array<string>;
}

/**
 * Check if a given object implements the ProductCustomizerRequestModel interface.
 */
export function instanceOfProductCustomizerRequestModel(value: object): boolean {
    return true;
}

export function ProductCustomizerRequestModelFromJSON(json: any): ProductCustomizerRequestModel {
    return ProductCustomizerRequestModelFromJSONTyped(json, false);
}

export function ProductCustomizerRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCustomizerRequestModel {
    if (json == null) {
        return json;
    }
    return {
        
        'product': json['product'] == null ? undefined : json['product'],
        'selectedAddons': json['selectedAddons'] == null ? undefined : json['selectedAddons'],
    };
}

export function ProductCustomizerRequestModelToJSON(value?: ProductCustomizerRequestModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'product': value['product'],
        'selectedAddons': value['selectedAddons'],
    };
}

